import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface QuestionTooltipProps {
  tooltip: string;
}

/**
 * Inline superscript ⓘ tooltip that renders immediately after question text.
 * Must be placed INSIDE the <h2> or inline container so it appears at the
 * end of the question text, not on a separate line.
 */
export function QuestionTooltip({ tooltip }: QuestionTooltipProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center h-4 w-4 ml-1.5 align-super text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 rounded-full"
            aria-label="Help information"
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          className="bg-popover border shadow-md text-foreground max-w-xs z-[100]"
          side="top"
          sideOffset={6}
          collisionPadding={16}
        >
          <p className="text-sm">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
